import React, { useState, useEffect, memo } from "react";
import TableMain from "../shared/TableMain";

const PaidInvoices = ({
  data = [],
  CurrentPage,
  setCurrentPage,
  Last_page,
  total_pages,
}) => {
  const [OrdersData, SetOrdersData] = useState([]);

  const TableHeadData = [
    { title: "Date & Time", val: "created_at" },
    { title: "Sender", val: "Sender" },
    { title: "Receiver", val: "Receiver" },
    { title: "Customer Type", val: "CustomerType" },
    { title: "Order", val: "Order" },
    { title: "Driver", val: "Driver" },
    { title: "Amount", val: "Amount" },
    // { title: "Settlement", val: "Settlement" },
    { title: "Commission", val: "Commission" },
    { title: "Status", val: "status" },
  ];

  useEffect(() => {
    if (data && data?.length > 0) {
      const modifiedData = data?.map((values) => {
        const created_at = values?.charge_transaction?.created_at;
        const Sender = values?.stops[0]?.contact_name;
        const Receiver = values?.stops[1]?.contact_name;
        const Amount = values?.price;
        const Order = values?.stops[0]?.order_detail?.name;
        const Driver = values?.driver_name;

        const status =
          values?.charge_transaction?.status === "pending"
            ? "Unpaid"
            : values?.charge_transaction?.status === "completed"
            ? "Paid"
            : "";
        const CustomerType = values?.user_type;
        const Commission = values?.price - values?.driver_price;

        return {
          created_at,
          Sender,
          Receiver,
          CustomerType,
          Order,
          Driver,
          Amount,
          Commission,
          status,
        };
      });

      // Update the OrdersData state with the modified array
      SetOrdersData(modifiedData || []);
    }
  }, [data]);

  return (
    <>
      {OrdersData?.length > 0 && (
        <TableMain
          TableHeadData={TableHeadData}
          BodyData={OrdersData}
          Hasaction={false}
          CurrentPage={CurrentPage}
          setCurrentPage={setCurrentPage}
          Last_page={Last_page}
          total_pages={total_pages}
          TableType="accounting"
        />
      )}
    </>
  );
};

export default memo(PaidInvoices);
